//@flow

export const ArrowEnum = Object.freeze({
  'Old': 'old',
  'New': 'new'
})
